module.exports = __webpack_public_path__ + "img/tabs-bg-4.9d85ee39.png";